import React, {useState, useEffect} from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import ApiService from "../util/ApiService";
import UsersSearch from "../dashboard/calender/UsersSearch";
import CustomPagination from "../util/CustomPagination";
import AddUserToDepartmentModal from "./AddUserToDepartmentModal";

const DepartmentUserListModal = ({show, onHide, department}) => {

    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [filters, setFilters] = useState({
        user_id: '',
    });
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});

    useEffect(() => {
        if (show) {
            fetchUsers();
            setSelectedUser(null);
        }
    }, [show]);

    const fetchUsers = async (page = 1, user = true) => {
        if (!department?.id) return;
        setLoading(true);
        try {

            const params = {
                page: page,
                pagination: pagination.pageSize,
                department_id: department?.id,
                ...(user ? { user_id: filters?.user_id || 0 } : {})
            };


            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/users-list`,
                params,
                true
            );

            if (response.code === 200) {
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setUsers(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});
            } else {
                Swal.fire("Erro", "Erro ao carregar os usuários.", "error");
                setUsers([]);
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAddUser = async () => {
        if (!filters?.user_id) {
            Swal.fire("Atenção", "Selecione um usuário antes de adicionar.", "warning");
            return;
        }

        setLoading(true);
        try {
            const params = {
                department_id: department?.id,
                user_id:  filters?.user_id || 0
            };
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}departments/register-user`, params, true);

            if (response.code === 200) {
                Swal.fire("Sucesso", "Usuário adicionado ao departamento!", "success");
                fetchUsers(1, false);
                setSelectedUser(null);
            } else {
                Swal.fire("Erro", "Erro ao adicionar o usuário.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveUser = async (userId) => {
        Swal.fire({
            title: "Tem certeza?",
            text: "Essa ação removerá o usuário do departamento!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sim, remover!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const params = {
                        department_id: department?.id,
                        user_id:  userId || 0
                    };

                    const response = await ApiService.send("delete", `${process.env.REACT_APP_URL_API}departments/delete-user`, params, true);

                    if (response.code === 200) {
                        Swal.fire("Sucesso", "Usuário removido do departamento!", "success").then(() => {
                            fetchUsers();
                        });

                    } else {
                        Swal.fire("Erro", "Erro ao remover o usuário.", "error");
                    }
                } catch (error) {
                    ApiService.handleApiError(error);
                } finally {
                    setLoading(false);
                }
            }
        });
    };


    const handlePageChange = (page) => {
        fetchUsers(page);
    };


    return (
        <>
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Departamento - {department?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className=" p-3">
                    {/* Campo de pesquisa com botão */}
                    <div className="row">
                        <div className="col-12 d-flex align-items-center gap-2">
                            <div className="flex-grow-1">
                                <UsersSearch
                                    onUserSelect={(user) =>
                                        setFilters((prevFilters) => ({
                                            ...prevFilters,
                                            user_id: user?.value || "",
                                        }))
                                    }
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2">

                                <button type="button"
                                        className="btn btn-success"
                                        style={{height: '39px', marginTop: '16px'}}
                                        onClick={() => setShowAddModal(true)}
                                        disabled={loading}
                                >
                                    <i className="fa fa-plus"></i> Adicionar
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{ height: '39px', marginTop: '16px' }}
                                    onClick={() => fetchUsers(1, true)}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Carregando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-search me-2"></i> Buscar
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>


                    {/* Lista de Usuários */}
                    <ul className="list-group mt-3">
                        {users.length > 0 ? (
                            users.map((user) => (
                                <li key={user.id}
                                    className="list-group-item d-flex justify-content-between align-items-center">
                                    {user.name}
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemoveUser(user.id)}
                                            disabled={loading}>
                                        Remover
                                    </button>
                                </li>
                            ))
                        ) : (
                            <>
                            {loading ? (
                                    <li className="list-group-item text-center">
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Carregando...
                                    </li>
                                ) : users.length === 0 ? (
                                    <li className="list-group-item text-center">Nenhum usuário encontrado</li>
                                ) : (
                                    users.map((user) => (
                                        <li key={user.id} className="list-group-item">
                                            {user.name}
                                        </li>
                                    ))
                                )}
                            </>
                        )}
                    </ul>


                    {/* Seção de Adicionar Usuário */}
                    <div className="mt-3">
                        <CustomPagination
                            pagination={pagination}
                            onChange={handlePageChange}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary"  onClick={() =>onHide()} disabled={loading}>
                    Fechar
                </button>
            </Modal.Footer>
        </Modal>

            {showAddModal && (
                <AddUserToDepartmentModal
                    show={showAddModal}
                    onHide={() => setShowAddModal(false)}
                    department={department}
                    onSuccess={() => fetchDepartment(1)}
                />
            )}
</>
    );
};

export default DepartmentUserListModal;
